import React, {
  Dispatch,
  SetStateAction,
  VFC,
  useContext,
  useState
} from 'react';
import { useHooks } from './useHooks';
import { Typography } from '@material-ui/core';
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { SiteProcessDatePicker } from '../../input/ProcessDatePicker';
import { TGanttSearchForm } from '../../../../types/process';
import { useStyles } from './useStyles';
import LoadingComponent from '../../../LoadingComponent';
import { DEFAULT_MESSAGE_NO_DATA } from '../../../../const/Const';
import {
  GANTT_CHART_HTML_ID,
  GANTT_SEARCH_HTML_ID
} from '../../../../const/ProcessConst';
import Loading from '../../../molecules/Loading';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import { AttendanceGanttChart } from '../AttendanceGanttChart';
import { AttendanceEditModal } from '../AttendanceEditModal';
import { useRecoilValue } from 'recoil';
import { attendanceGanttData } from '../../../../GlobalState';
import { AttendanceAddModal } from '../AttendanceAddModal';
import { AttendanceBulkUpdateModal } from '../AttendanceBulkUpdateModal';

export type TProps = {
  constructId: number;
  isOpenAddModal: boolean;
  setIsOpenAddModal: Dispatch<boolean>;
  isLoading: boolean;
  setIsLoading: Dispatch<boolean>;
  isOpenAdd: boolean;
  setIsOpenAdd: any;
  initialVisibleRange: any;
};

export const AttendanceGanttView: VFC<TProps> = props => {
  // dateStringからDateオブジェクトを作成
  const date = new Date();

  // 日付が月曜日になるように調整
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day; // 日曜日の場合は-6、それ以外は1-day

  // 週の最初の日（月曜日）を取得
  const monday = new Date(date);
  monday.setDate(monday.getDate() + diff);

  // 月曜日から30日後の日付を計算
  const dateAfter30Days = new Date(monday);
  dateAfter30Days.setDate(monday.getDate() + 30);

  const [bulkIsOpen, setBulkIsOpen] = useState<boolean>(false);
  const [bulkSelectId, setBulkSelectId] = useState<number>(0);

  const initialGanttData = useRecoilValue(attendanceGanttData);

  const {
    constructId,
    isOpenAddModal,
    setIsOpenAddModal,
    isLoading,
    setIsLoading
  } = props;
  const {
    calendarRef,
    isOpenEditModal,
    setIsOpenEditModal,
    editId,
    handleEdit,
    initialResourceAreaColumns,
    initialResourceAreaWidth,
    isLoadingForModal
  } = useHooks({
    constructId,
    isOpenAddModal,
    setIsOpenAddModal,
    setIsLoading,
    setBulkIsOpen,
    setBulkSelectId,
    initialVisibleRange: props.initialVisibleRange
  });

  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  return (
    <>
      {/* ガントチャート */}
      <div id={GANTT_CHART_HTML_ID}>
        {isLoading ? (
          <LoadingComponent />
        ) : initialGanttData?.resources.length > 0 ? (
          <>
            {/* モーダルclose時のローディング処理 */}
            <Loading open={isLoadingForModal} />

            {/*{assignTotallOfDate && assignTotallOfDate.length > 0 &&*/}
            <AttendanceGanttChart
              calendarRef={calendarRef}
              eventStartEditable={
                authInfo?.role != ROLE['OUTSIDE_PARTNER'] ? true : false
              }
              eventDurationEditable={
                authInfo?.role != ROLE['OUTSIDE_PARTNER'] ? true : false
              }
              initialGanttData={initialGanttData}
              initialResourceAreaColumns={initialResourceAreaColumns}
              initialResourceAreaWidth={initialResourceAreaWidth}
              handleEdit={handleEdit}
              constructId={constructId}
              setIsLoading={setIsLoading}
              initialVisibleRange={props.initialVisibleRange}
            />
            {/*}*/}
          </>
        ) : (
          <>
            <div className={classes.noDataMesage}>
              {DEFAULT_MESSAGE_NO_DATA}
            </div>
          </>
        )}
      </div>
      {/* 編集モーダル */}
      <AttendanceEditModal
        isOpen={isOpenEditModal}
        setIsOpen={setIsOpenEditModal}
        id={editId}
        constructId={constructId}
        setIsLoadingGantt={setIsLoading}
      />
      {/* 工程追加モーダル */}
      <AttendanceAddModal
        isOpen={props.isOpenAdd}
        setIsOpen={props.setIsOpenAdd}
        constructId={constructId}
        setIsLoadingGantt={setIsLoading}
        initialVisibleRange={props.initialVisibleRange}
      />

      <AttendanceBulkUpdateModal
        isOpen={bulkIsOpen}
        setIsOpen={setBulkIsOpen}
        initialVisibleRange={props.initialVisibleRange}
        bulkSelectId={bulkSelectId}
        initialGanttData={initialGanttData}
        constructId={constructId}
        setIsLoadingGantt={setIsLoading}
      />
    </>
  );
};
